import { Lock } from 'lucide-react';

/**
 * Stránka, na kterou uživatel nemá přístup (otevřená odkazem, z notifikace
 * nebo po odebrání přístupu). Místo prázdného nebo rozbitého modulu řekne proč
 * a vrátí na Přehled.
 *
 * `uvod` — domovská stránka účtu bez zaměstnance a bez přístupu ke KPI
 * Dashboardu: nemá kam vracet, jen řekne, že zatím nemá moduly.
 */
export default function BezPristupu({ onNavigate, uvod = false }) {
    return (
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <div style={{ textAlign: 'center', maxWidth: 360 }}>
                <span style={{
                    width: 52, height: 52, borderRadius: 10, margin: '0 auto 14px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(255,138,0,0.12)', color: '#FF8A00',
                }}>
                    <Lock size={24} />
                </span>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 6px' }}>
                    {uvod ? 'Zatím nemáš přidělené moduly' : 'Sem nemáš přístup'}
                </h2>
                <p style={{ fontSize: 13, lineHeight: 1.5, color: 'var(--text-muted)', margin: '0 0 16px' }}>
                    Přístupy k modulům nastavuje správce ve Správě → Uživatelé. Když ho potřebuješ, napiš mu.
                </p>
                {!uvod && <button type="button" onClick={() => onNavigate?.('prehled')}
                    style={{
                        padding: '8px 16px', borderRadius: 6, border: 'none', cursor: 'pointer',
                        background: '#FF8A00', color: '#fff', fontSize: 13, fontWeight: 600,
                    }}>
                    Zpět na Přehled
                </button>}
            </div>
        </div>
    );
}
